/**
 * @export
 * @class Util
 * util성으로 쓰이는 함수를 제공
 */
export default class Util {
  /**
   * getHeaderHeight
   * 현재 헤더의 사이즈를 리턴한다
   */
  getHeaderHeight() {
    let nHeaderHeight = TMON.util.gup('headerHeight')
      ? parseInt(TMON.util.gup('headerHeight'), 10)
      : $('header:first').outerHeight();
    // nHeaderHeight 없을 경우 웹 기본 값으로 처리
    if (!nHeaderHeight) {
      nHeaderHeight = 56;
    }
    if (TMON.oApp.sPlatform === 'PW') {
      nHeaderHeight = 0;
    }
    return nHeaderHeight;
  }

  /**
   * login
   * 로그인한다
   */
  login(
    sUrl,
    sAdditionalParam,
    bDeleteLayerHash = false,
    callback
  ) {
    let sReturnUrl = '';
    if (sUrl) {
      sReturnUrl = sUrl;
      if (bDeleteLayerHash) {
        sReturnUrl = sReturnUrl.replace('layer=open&', '');
        sReturnUrl = sReturnUrl.replace('layer=open', '');
      } 
      if (sAdditionalParam) {
        sReturnUrl = TMON.util.aup(sReturnUrl, sAdditionalParam);
      }
    }

    if (TMON.oApp.sPlatform === 'MA') {
      this.loginApp();
    } else if (TMON.oApp.sPlatform === 'MW') {
      if (!TMON.oLoginModal) {
        TMON.oLoginModal = new LoginModal();
      }
      TMON.oLoginModal.openLoginModal(sReturnUrl);
    } else {
      TMON.oMain.openLoginModal(() => {
        this.afterLogin(sReturnUrl);
        if (typeof callback === 'function') callback();
      });
    }
  }

  loginApp() {
    TMON.app.callApp('webview', 'login', true);
  }

  afterLogin(sReturnUrl) {
    if (sReturnUrl) {
      window.location.href = sReturnUrl;
      return;
    }
    TMON.bLogin = true;
    if (TMON.oApp.oQna) {
      TMON.oApp.oQna.init();
      // 문의 등록하기 버튼 활성화를 위해 display none 해준다.
      $('#writeQnaButton').css('display', 'none');
    }
    if (TMON.oApp.oReview) {
      TMON.oApp.oReview.initPhotoReview();
      TMON.oApp.oReview.initReview();
    }
  }

  /**
   * 레이어 보임 함수
   * @param htInfo 레이어를 보이기 위해 필요한 정보를 담은 객체
   *  {{
   *      welTargetLayer target 레이어 element
   *      bSetHash hash 추가 여부. false 로 설정하면 레이어 오픈시 #layer=open 이 추가되지 않음
   *      bUseHistorybackOnClose 해당 레이어 닫기 버튼 실행시 history.back() 을 할 지 여부. false 로 설정시 history.back() 하지 않고 해당 레이어를 hide() 함
   *      bShowDimmed dimmed 를 보여줄 지 말 지
   *      bPullToRefresh 레이어를 열었을 때 네이티브의 pull to refresh를 사용할 것인지
   *  }}
   */
  handleOpenLayer = htInfo => {
    const htOptions = htInfo;
    if (htOptions.bSetHash === undefined) {
      htOptions.bSetHash = true;
    }
    if (htOptions.bUseHistorybackOnClose === undefined) {
      htOptions.bUseHistorybackOnClose = true;
    }
    if (htOptions.bShowDimmed === undefined) {
      htOptions.bShowDimmed = true;
    }
    if (htOptions.bPullToRefresh === undefined) {
      htOptions.bPullToRefresh = true;
    }

    const sRandomStringForLayer = Math.random()
      .toString(36)
      .slice(2);
    // Math.random().toString(36).slice(2);

    if (htOptions.bSetHash) {
      // 레이어가 열렸음을 history에 추가
      TMON.util.setHash('layer', `open-${sRandomStringForLayer}`);
      TMON.oApp.setStorage('sRandomStringForLayer', sRandomStringForLayer);
    }

    if (!htOptions.bUseHistorybackOnClose) {
      htOptions.welTargetLayer.attr('data-closeType', 'remove');
    }

    if (htOptions.bPullToRefresh === false && TMON.oApp.sPlatform === 'MA') {
      htOptions.welTargetLayer.attr('data-pullToRefresh', 'false');
      TMON.app.callApp(
        'webview',
        'setWebProperties',
        '{"nestedScrollEnable": false}'
      );
    }

    // 바닥 스크롤 잠금
    if (TMON.oApp.sPlatform !== 'PW') {
      TMON.util.fixBodyForLayer(/* block setHash */ true);
    }

    const nLastZindex = TMON.oApp.getStorage('htLastOpenLayer')
      ? TMON.oApp.getStorage('htLastOpenLayer').nZindex + 2
      : 1100;

    TMON.oApp.setStorage('htLastOpenLayer', {
      welLastOpenLayer: htOptions.welTargetLayer,
      nZindex: nLastZindex,
    });

    // 레이어 보임
    htOptions.welTargetLayer.show().css('zIndex', nLastZindex);
    $('#_layerContainer').show();

    // PC에서 dimmed 보임
    if (htOptions.bShowDimmed && TMON.oApp.sPlatform === 'PW') {
      $('#_dimmedOnPc')
        .show()
        .css('zIndex', nLastZindex - 1);
    }
  };

  /**
   * 레이어의 z-index를 결정하는 함수
   * handleOpenLayer 유틸을 사용하는 레이어는 해당 유틸에서 결정하고 있다.
   * @param targetLayer z-index를 설정할 레이어
   */
  setPopupLayerZIndex = targetLayer => {
    const storedZIndex = TMON.oApp.getStorage('popupLayerZIndex');

    if (storedZIndex === undefined) {
      TMON.oApp.setStorage('popupLayerZIndex', 1100);
      $(targetLayer).css('z-index', 1100);
    } else {
      TMON.oApp.setStorage('popupLayerZIndex', storedZIndex + 2);
      $(targetLayer).css('z-index', storedZIndex + 2);
    }
  };

  /**
   * membershipGradeCode를 받아 Grade 관련 정보를 반환
   * @param {number} membershipGradeCode
   */
  getGradeInfo(membershipGradeCode) {
    let returnObj = {};

    switch (membershipGradeCode) {
      case 100:
        returnObj.sGradeClass = 'first';
        returnObj.sGradeName = 'THE FIRST';
        break;
      case 1:
        returnObj.sGradeClass = 'vvip';
        returnObj.sGradeName = 'VVIP';
        break;
      case 2:
        returnObj.sGradeClass = 'vip';
        returnObj.sGradeName = 'VIP';
        break;
      case 3:
        returnObj.sGradeClass = 'gold';
        returnObj.sGradeName = 'GOLD';
        break;
      case 4:
        returnObj.sGradeClass = 'silver';
        returnObj.sGradeName = 'SILVER';
        break;
      case 5:
        returnObj.sGradeClass = 'new';
        returnObj.sGradeName = 'NEW';
        break;
      default:
        break;
    }

    if (!TMON.oApp.htStorage.htStaticData.bVisibleOldGrade) {
      returnObj = {
        sGradeClass: 'common',
        sGradeName: '',
      };
    }

    return returnObj;
  }

  /**
   * 맨위로 버튼 노출
   * FastScroll 노출 - CallApp, Web에서 FastScroll은 '구매하기'보다 하단에 위치)
   */
  showGoTopButtonFastScroll = () => {
    TMON.app.callApp(
      'webview',
      'setWebProperties',
      '{"bShowGoTopButton" : true}'
    );
    $('.tlbarwp').show();
  };

  /**
   * 맨위로 버튼 숨김
   * FastScroll 숨김 - CallApp, Web에서 FastScroll은 '구매하기'보다 하단에 위치
   */
  hideGoTopButtonFastScroll = () => {
    TMON.app.callApp(
      'webview',
      'setWebProperties',
      '{"bShowGoTopButton" : false}'
    );
    $('.tlbarwp').hide();
  };

  /**
   * 날짜 정보(2018-01-01 15:00:00)를 받아서 요일 등의 정보를 추가하여 반환
   * @param sTimeText
   */
  getDateInfo = sTimeText => {
    const aDaysOfWeekString = ['일', '월', '화', '수', '목', '금', '토'];
    const htDateInfo = {
      sDaysOfWeek: '',
      sYear: sTimeText.substring(0, 4),
      sMonth: sTimeText.substring(5, 7),
      sDay: sTimeText.substring(8, 10),
      sHour: sTimeText.substring(11, 13),
      sMinute: sTimeText.substring(14, 16),
      sSecond: sTimeText.substring(17, 19),
    };
    htDateInfo.sDaysOfWeek =
      aDaysOfWeekString[
        new Date(
          `${htDateInfo.sYear}-${htDateInfo.sMonth}-${htDateInfo.sDay}`
        ).getDay()
      ];
    return htDateInfo;
  };

  getPlatform = () => {
    let sPlatform;
    if (TMON.sDevice === 'PW') {
      sPlatform = 'PW';
    } else if (TMON.view_mode === 'app') {
      sPlatform = 'MA';
    } else {
      sPlatform = 'MW';
    }
    return sPlatform;
  };

  getOuterHeight = el => {
    let nHeight = el.outerHeight();
    if (nHeight < 0 || TMON.oApp.oUtil.isInternetExplorer9) {
      nHeight = el.get(0) ? el.get(0).offsetHeight : 0;
    }
    return nHeight;
  };

  /**
   * el(해당 엘리먼트)이 화면에 보여지는 만큼의 height 계산
   */
  getVisibleHeight = el => {
    let elBottom = 0;
    let elTop = 0;
    let scrollBot = 0;
    let scrollTop = 0;
    let visibleBottom = 0;
    let visibleTop = 0;
    scrollTop = $(window).scrollTop();
    scrollBot = scrollTop + $(window).height();
    elTop = el.offset().top;
    elBottom = elTop + TMON.oApp.oUtil.getOuterHeight(el);
    visibleTop = elTop < scrollTop ? scrollTop : elTop;
    visibleBottom = elBottom > scrollBot ? scrollBot : elBottom;
    return visibleBottom - visibleTop;
  };

  /**
   * setPositioningOnBasedElementOnPC
   * 대상 엘리먼트를 기준점 엘리먼트 기준으로 배치한다. 화면의 여러 요소들을 고려한다.
   * PC 환경에서만 사용이 가능한 점 주의.
   * @param htInfo
   */
  setPositioningOnBasedElementOnPC = htInfo => {
    const htRefine = htInfo;
    const htCss = {
      position: 'absolute',
      top:
        htRefine.welBased.offset().top -
        $('#content').offset().top +
        htRefine.nTop,
      width: htRefine.nWidth,
    };
    if (htRefine.nLeft || htRefine.nLeft === 0) {
      htCss.left = '50%';
      htCss.marginLeft = `${(window.innerWidth / 2 -
        htRefine.welBased.offset().left) *
        -1 +
        htRefine.nLeft}px`;
    }
    if (htRefine.nRight || htRefine.nRight === 0) {
      htCss.right = '50%';
      htCss.marginRight = `${(htRefine.welBased.offset().left +
        htRefine.welBased.innerWidth() -
        window.innerWidth / 2) *
        -1 +
        htRefine.nRight}px`;
    }
    htRefine.welTarget.css(htCss);
  };

  setPositioningCenterOnPc = welTargetLayer => {
    welTargetLayer.css({
      position: 'fixed',
      top: '50%',
      left: '50%',
      marginTop: `-${welTargetLayer.outerHeight() / 2}px`,
      marginLeft: `-${welTargetLayer.outerWidth() / 2}px`,
    });
  };

  /**
   * 사용자가 접속한 브라우저가 IE9 인지를 특정하여 리턴
   * @returns {boolean}
   */
  isInternetExplorer9() {
    if (navigator.userAgent.indexOf('9.0') === 30) {
      return true;
    }
    return false;
  }

  /**
   * 사용자가 접속한 브라우저가 IE11 미만인지 특정하여 리턴
   * @returns {boolean}
   */
  isInternetExplorerUnder11() {
    const agent = navigator.userAgent.toLowerCase();
    if (agent.indexOf('msie') !== -1) {
      return true;
    }
    return false;
  }

  /**
   * 사용자가 접속한 브라우저가 IE 인지 (IE11 포함)
   * @returns {boolean}
   */
  isInternetExplorer() {
    const agent = navigator.userAgent.toLowerCase();
    if (
      (navigator.appName === 'Netscape' &&
        navigator.userAgent.search('Trident') !== -1) ||
      agent.indexOf('msie') !== -1
    ) {
      return true;
    }
    return false;
  }

  getDiscountInfos(dealInfo) {
    const { priceInfo, isHideReview } = dealInfo;
    const { viewPaymentDiscountInfoKey } = dealInfo.priceInfo;
    const discountInfos =
      dealInfo.priceInfo.discountInfos[viewPaymentDiscountInfoKey];

    const { isUniformlyPrice } = dealInfo;
    const { isDelegatePriceOver } = dealInfo;
    const { userPoint } = dealInfo;
    let isVisibleDelegatePriceOver = isDelegatePriceOver;
    let isVisibleOriginalPrice = false;
    let sVisibleDiscountInfo = '';
    let sTestCodeOnPriceDefinitionList = '';

    if (priceInfo.originalPrice !== discountInfos.price) {
      isVisibleOriginalPrice = true;
    }

    if (discountInfos.isCoupon === true) {
      isVisibleDelegatePriceOver = false;
      sVisibleDiscountInfo = 'discountLabel';

      sTestCodeOnPriceDefinitionList = '040';
    } else if (discountInfos.isPartner === true) {
      isVisibleDelegatePriceOver = false;
      sVisibleDiscountInfo = 'discountLabel';

      sTestCodeOnPriceDefinitionList = '050';
    } else if (isUniformlyPrice === true && discountInfos.price > 0) {
      // commonBasicInfo.jsp 와는 다르게 옵션딜인지 아닌지 여부는 따지지 않는다. 왜냐하면 옵션딜일 경우 dealContents 는 표시되지 않았을 것이고, 연관딜은 옵션딜이 아니기 때문에.
      isVisibleDelegatePriceOver = false;
      sVisibleDiscountInfo = '균일가';
      sTestCodeOnPriceDefinitionList = '010';
    } else if (isUniformlyPrice === true && discountInfos.price === 0) {
      isVisibleDelegatePriceOver = false;
      isVisibleOriginalPrice = false;
      sVisibleDiscountInfo = 'none';

      sTestCodeOnPriceDefinitionList = '020';
    } else if (
      discountInfos.discountRate !== 100 &&
      discountInfos.price === 0 &&
      isDelegatePriceOver === 'false' &&
      isUniformlyPrice === 'false'
    ) {
      isVisibleDelegatePriceOver = false;
      isVisibleOriginalPrice = false;
      sVisibleDiscountInfo = 'none';

      sTestCodeOnPriceDefinitionList = '030';
    } else if (discountInfos.discountRate > 0) {
      sVisibleDiscountInfo = 'discountRate';

      sTestCodeOnPriceDefinitionList = '060';
    } else if (TMON.oApp.sPlatform === 'PW') {
      sVisibleDiscountInfo = 'none';

      sTestCodeOnPriceDefinitionList = '070';
    }

    if (
      sVisibleDiscountInfo === 'discountLabel' &&
      discountInfos.discountLabel === '티몬가'
    ) {
      sVisibleDiscountInfo = 'none';
      sTestCodeOnPriceDefinitionList = '080';
    }

    return {
      paymentDiscountInfoKey: dealInfo.priceInfo.paymentDiscountInfoKey,
      viewPaymentDiscountInfoKey: dealInfo.priceInfo.viewPaymentDiscountInfoKey,
      originalPrice: dealInfo.priceInfo.originalPrice,
      discountAmount: discountInfos.discountAmount,
      discountLabel: discountInfos.discountLabel,
      discountRate: discountInfos.discountRate,
      discountType: discountInfos.discountType,
      price: discountInfos.price,
      isCoupon: discountInfos.isCoupon,
      isPartner: discountInfos.isPartner,
      isVisibleDelegatePriceOver,
      isVisibleOriginalPrice,
      sVisibleDiscountInfo, // '균일가/discountLabel/discountRate/none',
      sTestCodeOnPriceDefinitionList, // 010 ~ 090
      isDuplicated: priceInfo.isDuplicated,
      userPoint,
      isHideReview,
    };
  }

  /**
   * getDayType1 : MM/dd (day) 형태로 리턴한다.
   * @param {*} sDate
   */
  getDayType1(sDate) {
    if (!sDate) {
      return '';
    }
    const week = ['일', '월', '화', '수', '목', '금', '토'];
    const dayOfWeek = week[new Date(sDate).getDay()];
    const sReturnText = `${sDate.substring(5, 7)}/${sDate.substring(
      8,
      10
    )}(${dayOfWeek})`;
    return sReturnText;
  }

  getTextWithBar(sTestingText1, sOutputText1, sTestingText2, sOutputText2) {
    /* eslint-disable no-unneeded-ternary */
    return `${sTestingText1 ? sOutputText1 : ''}${
      sTestingText1 && sTestingText2 ? '<span class="txt_bar bar"></span>' : ''
    }${sTestingText2 ? sOutputText2 : ''}`;
  }

  /**
   * 특정 depth의 옵션 트리 반환
   * @param {*} nDepth
   * @param {*} aIndex 각 depth별 Index
   * 마지막 뎁스를 제외하고는 childNodes를 return
   * 마지막 뎁스는 해당 아이템을 return
   */
  getOptionTreeChildNodesByDepth(nDepth, aIndex = [0]) {
    const {
      optionTree: {
        data: { treeData: optionTree },
      },
    } = TMON.oApp.htStorage;

    const traverse = (nCur, aChildNodes, nMax) => {
      if (nCur === nMax) {
        return aChildNodes;
      }

      if (!aIndex || isNaN(aIndex[nCur])) {
        return [];
      }

      return traverse(nCur + 1, aChildNodes[aIndex[nCur]].childNodes, nMax);
    };

    return traverse(0, optionTree.childNodes, nDepth);
  }

  /**
   * 특정 depth의 리뷰를 가진 옵션 트리 반환
   * @param {*} nDepth
   * @param {*} aIndex 각 depth별 Index
   * 마지막 뎁스를 제외하고는 childNodes를 return
   * 마지막 뎁스는 해당 아이템을 return
   */
  getReviewOptionTreeChildNodesByDepth(nDepth, aIndex = [0]) {
    const {
      reviewOptionTree: {
        data: { treeData: optionTree },
      },
    } = TMON.oApp.htStorage;

    const traverse = (nCur, aChildNodes, nMax) => {
      if (nCur === nMax) {
        return aChildNodes;
      }

      if (!aIndex || isNaN(aIndex[nCur])) {
        return [];
      }

      return traverse(nCur + 1, aChildNodes[aIndex[nCur]].childNodes, nMax);
    };

    return traverse(0, optionTree.childNodes, nDepth);
  }

  /**
   * sEndDate = YYYMMDD HH:SS:ss
   */
  isTimeOver = sEndDate => {
    const nTimeStamp = parseInt(TMON.currentTimeTimestamp, 10);
    if (isNaN(nTimeStamp)) {
      return false;
    }

    try {
      const oStart = new Date(nTimeStamp);
      const oEnd = new Date(sEndDate.replace(' ', 'T'));

      if (oStart.getTime() < oEnd.getTime()) {
        return false;
      }
      return true;
    } catch (e) {
      console.warn(e);
    }

    return false;
  };

  lotteDealImgLazy = (htmlText, sAddClass) => {
    const replacedHtmlText = htmlText
      .replace(/src=/gm, 'data-src=')
      .replace(
        /<img/gm,
        `<img src='//img1.tmon.kr/static2/img/blank.png' class="${sAddClass}"`
      );
    return `<div class="lotte_deal-data">${replacedHtmlText}</div>`;
  };

  regularDealImgLazy = (htmlText, sAddClass) => {
    // img 태그의 src를 blank 파일로 변경하고
    const imgSrcRegex = /<img(.*?)src="(.*?)"(.*?)>/gim;
    let replacedHtmlText = htmlText.replace(
      imgSrcRegex,
      '<img src="//img1.tmon.kr/static2/img/blank.png" data-src="$2" $1 $3>'
    );
    const imgAltRegex = /<img src="(.*?)" data-src="(.*?)"(.*?)(alt|title)="(.*?)"(.*?)>/gim;
    replacedHtmlText = replacedHtmlText.replace(
      imgAltRegex,
      `<img src="$1" data-src="$2" alt="$4" class="${sAddClass}">`
    );
    const imgBlankAltRegex = /<img src="(.*?)" data-src="(.*?)" alt="" class="(.*?)">/gim;
    replacedHtmlText = replacedHtmlText.replace(
      imgBlankAltRegex,
      '<img src="$1" data-src="$2" alt="상품 상세 이미지" class="$3">'
    );
    return replacedHtmlText;
  };

  /**
   * 레이지로드를 위한 html 데이터를 변환
   */
  getLazyInnerHtml = (htmlText, sAddClass = 'unload') => {
    /* 롯데 백화점 연동딜 유무 */
    const isLotteHtml = new RegExp('data-review-type="html"').test(htmlText);
    return isLotteHtml
      ? this.lotteDealImgLazy(htmlText, sAddClass)
      : this.regularDealImgLazy(htmlText, sAddClass);
  };

  /**
   * 레퍼러 주소가 딜상세인지 아닌지 판단하여 리턴
   */
  isTmonDealDetailReferrer = () => {
    const aReferrer = document.referrer.split('/');
    if (!aReferrer[2] || !aReferrer[3]) {
      return false; // 레퍼러가 없으면 false
    }
    if (
      aReferrer[2].indexOf('ticketmonster') === -1 &&
      aReferrer[2].indexOf('tmon') === -1
    ) {
      return false; // 도메인에 티몬 관련 도메인이 없으면 false
    }
    if (
      aReferrer[3].indexOf('deal') === -1 &&
      aReferrer[3].indexOf('deals') === -1
    ) {
      return false; // 첫번째 path 가 deal 이나 deals 가 아니면 false
    }
    return true;
  };

  scrollTop = (wel, nTop) => {
    $(window).scrollTop(nTop);
  };

  /**
   * 사용자가 사용하고 있는 Device 가 touchDevice 인지 아닌지 체크하여 리턴
   */
  isTouchDevice = () => {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch (e) {
      return false;
    }
  };

  /**
   * 기획전 이동
   * sPlanId : 기획전 ID
   * bNewWindow : 새창 여부. 앱에서는 무조건 새 모달웹뷰
   */
  redirectPlanning = (sPlanId, bNewWindow) => {
    const sUrl = TMON.htLocal.htURL.www_planning.replace('{}', sPlanId);
    if (TMON.view_mode === 'app') {
      TMON.app.callApp('event', 'goIntegratedPlan', sPlanId); // 앱일 때는 콜앱으로 기획전 처리
      return;
    }

    if (bNewWindow) {
      window.open(sUrl, '_blank');
    } else {
      location.href = sUrl;
    }
  };

  /**
   * URL 이동
   * sUrl : 이동할 URL
   * bNewWindow : 새창 여부. 앱에서는 무조건 새 모달웹뷰
   */
  redirectUrl = (sUrl, bNewWindow) => {
    if (TMON.view_mode === 'app') {
      TMON.app.callApp(
        'webview',
        'showNaviWebView',
        '티몬',
        TMON.util.aup(sUrl, TMON.sAppQuery),
        false,
        false,
        true
      );
      return;
    }

    if (bNewWindow) {
      window.open(sUrl, '_blank');
    } else {
      location.href = sUrl;
    }
  };

  getUrlWithNewHash = (key, newValue) => {
    const { href } = window.location;
    const reg = new RegExp(`(${key}=)([\\w-_]+)(&)?`);
    return href.replace(reg, `$1${newValue}$3`);
  };

  replaceHash(key, newValue) {
    window.history.replaceState(
      null,
      '',
      this.getUrlWithNewHash(key, newValue)
    );
  }

  /**
   * 배열의 원소가 undefined인 경우 ''를 리턴해서 문자열로 만듦
   * @param aString
   */
  getTruthyString = aString => {
    const aConverted = aString.map(sItem => (sItem ? sItem : ''));
    return aConverted.join(' ');
  };

  /**
   * 현재 시간과 파라미터로 받은 시간을 비교해 전인지 후인지 리턴
   */
  async isAfter(time = '') {
    let isAfter = false;

    if (time) {
      const start = new Date(time);
      const currentTime = await TMON.util.getCurrentTime(
        TMON.htLocal.htURL.localeUrl
      );
      const now = new Date(currentTime);
      if (start < now) {
        isAfter = true;
      }
    }

    return isAfter;
  }

  /**
   * Object가 비어있는지 검사
   * @param obj
   */
  isEmpty(obj) {
    if (obj instanceof Object) {
      for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }
    }

    return true;
  }

  /**
   * Object data가 Service Unavailable인지 검사
   * api 호출되어 반환된 obj에서 503 에러를 반환받았는지 검사
   */
  isUnavailable(obj) {
    if (
      this.isEmpty(obj) ||
      (obj && obj.httpCode === 503 && obj.httpStatus === 'Service Unavailable')
    ) {
      return true;
    }

    return false;
  }

  /**
   * URL Query String 추출
   */
  getUrlParams() {
    const params = {};
    window.location.search.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      (str, key, value) => {
        params[key] = value;
      }
    );
    return params;
  }

  /**
   * 메인 카테고리 번호를 반환한다.
   * SC 카테고리 딜인 경우 미러링 카테고리 번호를 반환한다.
   * 옵션 isScDeal true인 경우 SC 카테고리 번호를 반환한다.
   * @param {boolean} isScDeal
   */
  getMainCategoryNo(isScDeal = false) {
    return !isScDeal
      ? TMON.htStaticData.htCategoryInfo.mainCategoryNo
      : TMON.htStaticData.htCategoryInfo.scCategoryNo;
  }

  /**
   * 함수형 개발 Util function
   */
  pipe = (...funcs) => v => {
    return funcs.reduce((res, func) => {
      return func(res);
    }, v);
  };

  inject = fn => a => b => fn(a, b);

  take = this.inject((length, iter) => {
    const res = [];
    for (const item of iter) {
      res.push(item);
      if (res.length === length) return res;
    }
    return res;
  });

  unshift = this.inject((item, iter) => [item, ...iter]);

  /**
   * textNode 이외 Node를 제거해 준다.
   * exclude에 tagName을 추가하여 예외 하면 해당 Element는 출력된다.
   * @param content
   * @param exclude
   * @returns {*}
   */
  removeStringElement = (content = '', exclude = []) => {
    const filterCondition = ['#text'].concat(exclude);
    const el = document.createElement('div');
    el.innerHTML = content;

    for (const node of el.childNodes) {
      if (!filterCondition.includes(node.nodeName)) {
        el.removeChild(node);
      }
    }

    return el.innerHTML;
  };

  /**
   * 딜리스트 mask HTML 생성
   * @param {Object} dealInfo 
   */
  getDealMaskHtml = (dealInfo) => {
    const { dealMax, contentsLevel } = dealInfo;
    const isPc = TMON.sDevice === 'PW';
    let maskClass = isPc ? "p-item__mask" : "mask";
    let maskText = "";
    let sHtml = "";

    if (dealMax && dealMax.soldOut) {
      maskClass += isPc ? " p-item__mask--soldout" : " sold_out";
      maskText = "매진";
    } else if (
      (contentsLevel === "TOP" || contentsLevel === "MIDDLE") &&
      !TMON.oApp.htStorage.htStaticData.isAdultCert
    ) {
      maskClass += isPc ? " p-item__mask--adultonly" : " adult_only";
      maskText = "미성년자 열람 제한";
    }

    if (maskText) {
      if (isPc) {
        sHtml = `<div class="${maskClass}">
          <span class="mask-text">${maskText}</span>
        </div>`;
      } else {
        sHtml = `<div class="${maskClass}">
          <div class="mask_bg"></div>
          <div class="mask_info">
            <span class="text">${maskText}</span>
          </div>
        </div>`;
      }
    }
    return sHtml;
  }
}
